module.exports = __webpack_public_path__ + "static/media/result_vi_ja.30b5c964.jpg";